import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('reports.data.filters.numberRangeFilter', {
    previewTextFull: 'over or equal to {startNumber} and under or equal to {endNumber}',
    previewTextStart: 'over or equal to {startNumber}',
    previewTextEnd: 'under or equal to {endNumber}',
});
